import { gql } from "@apollo/client";

export const SAVE_DRIVERS = gql`
  mutation saveDrivers($documentId: Int!, $drivers: [DriverInput]!) {
    saveDrivers(documentId: $documentId, drivers: $drivers) {
      commandId
      correlationId
    }
  }
`;
